
<div>
  <label class="label-infra-size">
    {{ $t("workspace_rde.rde_detail.label.infra_size") }}
  </label>
  <div class="grid grid-cols-2 gap-x-2">
    <div class="flex">
      <Select
        :id="`${serviceType}-cpu-unit`"
        v-model="values[serviceType].resourceSize.cpuUnit"
        :items="cpuUnitOptions"
        :label="`CPU ${$t('workspace_rde.rde_detail.label.unit')}`"
        class="select-v2 flex-1"
        :solo="false"
        @change="(v) => hanldeChange('cpu', v)"
      />
      <Input
        :id="`${serviceType}-cpu-value`"
        v-model="values[serviceType].resourceSize.cpu"
        :label="`CPU - ${$t('workspace_rde.rde_detail.label.value')}`"
        type="number"
        appendClass="input-text-field-v2 flex-3"
        :rules="[rules.required, validateTotalSize('cpu')]"
        @blur="validate"
        @change="(v) => hanldeValueChange()"
      />
    </div>

    <div class="flex">
      <Select
        :id="`${serviceType}-memory-unit`"
        v-model="values[serviceType].resourceSize.memoryUnit"
        :items="memoryUnitOptions"
        :label="`Memory ${$t('workspace_rde.rde_detail.label.unit')}`"
        appendClass="select-v2 flex-1"
        :solo="false"
        @change="(v) => hanldeChange('memory', v)"
      />
      <Input
        :id="`${serviceType}-memory-value`"
        v-model="values[serviceType].resourceSize.memory"
        :label="`Memory - ${$t('workspace_rde.rde_detail.label.value')}`"
        type="number"
        appendClass="input-text-field-v2 flex-3"
        :rules="[rules.required, validateTotalSize('memory')]"
        @blur="validate"
        @change="(v) => hanldeValueChange()"
      />
    </div>

    <div class="switch-v2-group col-span-2">
      <Sw
        v-model="values[serviceType].gpuEnabled"
        inset
        appendClass="switch-v2"
        :disabled="!gpuAvailable"
        @input="switchGPUCore"
      ></Sw>
      <span class="text-switch">{{
        $t("workspace_rde.rde_detail.toggle.gpu_configuration")
      }}</span>
    </div>

    <Input
      v-if="values[serviceType].gpuEnabled"
      v-model="values[serviceType].resourceSize.gpu"
      :label="$t('workspace_rde.rde_detail.label.number_of_gpus')"
      :placeholder="
        $t('workspace_rde.rde_detail.placeholder.enter_number_of_gpus')
      "
      type="number"
      appendClass="input-text-field-v2"
      :rules="[rules.required, validateGPUInput]"
      :min="1"
      clearable
      @input="inputGPU"
    />
  </div>
</div>
